module.exports = __webpack_public_path__ + "img/mtn-logo.43d32360.jpg";